module.exports = __webpack_public_path__ + "n.no2.71c0d792.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/n.no2.jpg
// module id = Pm/Q
// module chunks = 0